/**
 * Created by lovely on 2016/8/29.
 */

var _ = require('underscore');

module.exports = function () {
  var points;

  this.parseData = function (pointList) {
    var p;
    var ps;
    var i = 0;
    var l;
    var s;
    points = [];
    if (!_.isEmpty(pointList)) {
      ps = pointList.replace(/\(/g, '').replace(/\)/g, '').split('|');
      l = ps.length;
      for (i; i < l; i++) {
        s = ps[i].split(',');
        p = {x: parseInt(s[0], 10), y: parseInt(s[1], 10)};
        if(parseInt(s[2]) === 1){
          p.t = 'M';
        }else{
          p.t = 'L';
        }
        points.push(p);
      }
    }
  };

  this.getBounds = function () {
    var i = 0;
    var l = points.length;
    var x, y, r, b;
    var p;
    var bound = {};
    if(points.length) {
      p = points[0];
      x = p.x;
      y = p.y;
      r = x;
      b = y;
      for (i = 1; i < l; i++) {
        p = points[i];
        x = Math.min(x, p.x);
        y = Math.min(y, p.y);
        r = Math.max(r, p.x);
        b = Math.max(b, p.y);
      }
    }
    bound.left = x;
    bound.top = y;
    bound.right = r;
    bound.bottom = b;
    bound.width = r - x;
    bound.height = b - y;
    return bound;
  };

  this.data = function(){
    return points;
  };
};


/** WEBPACK FOOTER **
 ** ./src/helper/PathData.js
 **/